// Vuex constants
export const TOKEN = "token"
export const REFRESH_TOKEN = "refresh_token"
export const TOKEN_EXPIRES = "expires"
export const USER_DATA = "userData"

export const TYPE_DOCUMENT_DECISION_RECOGNITION = 1
export const TYPE_DOCUMENT_DIPLOMA = 2
export const STATUS_IN_PROCESS = 1
export const STATUS_COMPLETE = 2
export const STATUS_ARCHIVED = 3
export const LoginPage = 'https://rrd.rcc.int/login'
export const SUPERUSER = 1
export const INSTITUTION_USER = 2
export const ECONOMY_VIEW_USER = 3
export const INSTITUTION_VIEW_USER = 4
export const PERMANENTLY_DECISION = 1
export const TEMPORARY_DECISION = 2

export const ECONOMY_BIH = 2;



